<template>
  <div id="clients">
    <div class="row spaced">
      <h1>Clients</h1>
      <i class="fas fa-plus newIcon" @click="$router.push('newclient')"></i>
    </div>
    <div class="header">
      <div class="card">
        <h2>Goodnight Games</h2>
        <p class="subtle-p">Newest Client</p>
      </div>
      <div class="card">
        <h2>34</h2>
        <p class="subtle-p">Total Clients</p>
      </div>
      <div class="card">
        <h2>3</h2>
        <p class="subtle-p">Late Invoices</p>
      </div>
    </div>
    <div class="clients collection">
      <div class="card" id="line">
        <p>Company</p>
        <p>Contact</p>
        <p>Outstanding Due</p>
        <p>Email</p>
        <p>Added On</p>
      </div>
      <div v-for="item in clients" :key="item.id">
        <div class="card" @click="openClient(item.id)">
          <p>{{item.company}}</p>
          <p>{{item.contact}}</p>
          <p>{{item.total_due}}</p>
          <p>{{item.email}}</p>
          <p>{{item.created}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "../main";
import firebase from "firebase";
export default {
  name: "ClientDashboard",
  data() {
    return {
      clients: [],
      user: "",
    };
  },
  methods: {
    openClient: function (id) {
      this.$router.push("/" + id);
    },
  },
  firestore() {
    this.user = firebase.auth().currentUser.uid; // This won't work if team members is implemented. This will only work for a single account
    return {
      clients: db.collection("clients").where("user_id", "==", this.user),
    };
  },
};
</script>

<style lang="scss" scoped>
#clients {
  h1 {
    text-align: left;
    margin: 0;
  }

  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .newIcon {
    cursor: pointer;
    font-size: 1.5rem;
    transition: 0.1s;

    &:hover {
      color: #0cce6b;
    }
  }

  width: 100%;
}

.header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-top: 15px;

  .card {
    background: #ffffff;
    padding: 15px 25px;
    margin: 0 15px;
    min-width: 250px;
    text-align: left;
    position: relative;
    border-radius: 2px;

    &:first-of-type {
      margin-left: 0;
    }

    &:last-of-type {
      margin-right: 0;
    }

    h2 {
      font-size: 1.5vw;
      margin: 0;
    }

    .subtle-p {
      font-size: 0.9rem;
      color: rgb(184, 184, 184);
      margin: 10px 0 0 0;
    }
  }
}

.clients {
  #line {
    background: none;
    padding: 0;
    margin: 0;
    cursor: default;

    p {
      padding: 20px 0 0 0;
      margin: 0;
    }
  }
  .card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background: #fff;
    margin: 10px 0;
    cursor: pointer;

    p {
      margin: 5px;
      min-width: 200px;
      padding: 10px;

      &:first-of-type {
        width: auto;
        margin-left: 0;
        text-align: left;
      }

      &:last-of-type {
        margin-right: 0;
        text-align: right;
      }
    }
  }
}
</style>